import React from 'react';
import { PiX } from 'react-icons/pi';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

export interface PropertyActiveFilterItem {
  id: string;
  label: string;
  href: string;
}

interface PropertyActiveFiltersProps {
  items: PropertyActiveFilterItem[];
  clearAllHref: string;
}

export const PropertyActiveFilters: React.FC<PropertyActiveFiltersProps> = ({
  items,
  clearAllHref,
}) => {
  const { t } = useI18n();

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="border-b bg-slate-50 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto overflow-y-hidden whitespace-nowrap pb-1">
          {items.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className="inline-flex max-w-full shrink-0 items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-left shadow-sm transition hover:border-slate-300"
              aria-label={t('catalog.properties.activeFilters.remove', {
                label: item.label,
              })}
            >
              <Text
                size="tiny"
                weight="medium"
                className="truncate text-slate-700"
              >
                {item.label}
              </Text>
              <PiX className="h-3.5 w-3.5 shrink-0 text-slate-500" />
            </a>
          ))}
        </div>

        <a
          href={clearAllHref}
          className="w-fit shrink-0 rounded-md px-2 py-1 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
        >
          {t('catalog.properties.activeFilters.clearAll')}
        </a>
      </div>
    </div>
  );
};
